import './instrument'

import ReactDOM from 'react-dom/client'
import App from './App'
import reportWebVitals from './reportWebVitals'

import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { configureStore } from './store'
// import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

const root = ReactDOM.createRoot(document.getElementById('root'))
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: (failureCount, error) => {
                const status = error?.response?.status

                // Don't retry for client errors (4xx)
                if (status >= 400 && status < 500) return false

                return failureCount < 1
            },
        },
    },
})

root.render(
    <QueryClientProvider client={queryClient}>
        <Provider store={configureStore({})}>
            <BrowserRouter basename={process.env.PUBLIC_URL}>
                <App />
            </BrowserRouter>
        </Provider>
        {/* TODO: uncomment if you need RQ devtools */}
        {/* <ReactQueryDevtools initialIsOpen={false} /> */}
    </QueryClientProvider>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
